<template>
    <div :class="rootClass" v-bind:style="positionStyle">
        <div :class="innerClass" v-on:click="handleSelection">
            <strong class="data title" :title="customerName">{{ customerName }}</strong>
            <div class="data">
                <span>{{ reservation.product.name }}</span>
                <strong v-if="!selected">({{ reservation.quantity }})</strong>
            </div>
            <span class="data" :title="intervalString">{{ intervalString }}</span>
            <ul v-if="shouldDisplayTariffs" class="tariffs">
                <li v-for="st in reservation.tariffs" :key="st.name">
                    <span>{{ st.name }}</span>
                    <strong>({{ st.quantity }})</strong>
                </li>
            </ul>
            <div v-if="shouldDisplayResources">
                <strong>Lugares:</strong>
                <ul>
                    <li v-for="sr in reservation.resources" :key="sr.id">
                        <span>{{ sr.name }}</span>
                    </li>
                </ul>
            </div>
            <div v-if="shouldDisplayReallocation">
                <strong>Lugares:</strong>
                <form class="container" v-on:submit.prevent="handleReallocationSubmit">
                    <div class="row">
                        <div class="col">
                             <ReservationResourceSelector
                                v-if="reallocationSeatMap"
                                :seatMap="reallocationSeatMap"
                                :currentResourceIds="reservationResourceIds"
                                @onSelectedResources="handleResourceSelectionChange"
                              />
                              <div v-else>Carregando...</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-primary btn-block" title="Salvar">
                                <i class="material-icons" style="vertical-align: middle">check</i>
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-block" title="Cancelar" v-on:click.prevent="setReallocation(false)">
                                <i class="material-icons" style="vertical-align: middle">cancel</i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div v-if="shouldDisplayDescription">
                <em>{{ reservation.description }}</em>
            </div>
            <div v-if="rescheduling">
                <form class="reschedule-form container-fluid" v-on:submit.prevent="handleRescheduleSubmit">
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <label for="schedule_date">Data</label>
                            <select class="form-control" :disabled="productLoading" v-model="scheduleDateValue" name="schedule_date" id="schedule_date">
                                <option v-for="option in dateOptions" :value="option.value" :key="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                            <span class="form-error">{{ validationMessage('schedule_date') }}</span>
                        </div>
                        <div class="col-md-6 form-group">
                            <label for="schedule_time_minutes">Horário</label>
                            <select class="form-control" :disabled="!isScheduleTimeMinutesAvailable" v-model="scheduleTimeMinutesValue" name="schedule_time_minutes" id="schedule_time_minutes">
                                <option v-for="option in hourOptions" :value="option.value" :key="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                            <span class="form-error">{{ validationMessage('schedule_time_minutes') }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <button type="submit" class="btn btn-primary btn-block" title="Salvar">
                                <i class="material-icons" style="vertical-align: middle">check</i>
                            </button>
                        </div>
                        <div class="col-md-6 form-group">
                            <button type="submit" class="btn btn-block" title="Cancelar" v-on:click.prevent="setReschedule(false)">
                                <i class="material-icons" style="vertical-align: middle">cancel</i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div v-else-if="displayChanges" class="changes">
                <div>
                    <strong>Alterações de agendamento</strong>
                    <a href="javascript:void(0)" title="Fechar" v-on:click="setChangesDisplay(false)">Fechar</a>
                </div>
                <ul>
                    <li v-for="change in reservation.changes" :key="change.formatted_schedule">{{ change.formatted_schedule }}</li>
                </ul>
            </div>
            <div v-else class="actions">
                <div>
                    <a href="javascript:void(0)" title="Reagendar reserva" v-on:click="setReschedule(true)">
                        <i class="material-icons" style="vertical-align: middle">update</i>
                    </a>
                </div>
                <div v-if="reservation.sale">
                    <a :href="reservation.sale.page_url" target="_blank" title="Visualizar venda">
                        <i class="material-icons" style="vertical-align: middle">more</i>
                    </a>
                </div>
                <div v-if="shouldDisplayChanges">
                    <a href="javascript:void(0)" title="Reagendamentos" v-on:click="setChangesDisplay(true)">
                        <i class="material-icons" style="vertical-align: middle">timeline</i>
                    </a>
                </div>
                <div v-if="shouldAllowReallocation">
                    <a href="javascript:void(0)" title="Realocar reserva" v-on:click="setReallocation(true)">
                        <i class="material-icons" style="vertical-align: middle">cached</i>
                    </a>
                </div>
                <div v-if="reservation.direct_link_page_url">
                    <a :href="reservation.direct_link_page_url" title="Ver Planne link" target="_blank">
                        <i class="material-icons" style="vertical-align: middle">link</i>
                    </a>
                </div>
                <div v-if="reservation.delete_url && !reservation.direct_link_page_url">
                    <a href="javascript:void(0)" title="Excluir reserva" v-on:click="handleDeletion">
                        <i class="material-icons" style="vertical-align: middle">delete</i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatepickerInput from './DatepickerInput';
import ReservationResourceSelector from './ReservationResourceSelector';
import { dateFromDateString } from '../../common/calendar';
import { MAX_MINUTE_DAY, minToHour, requestJson, validation, confirmValidationErrors, confirmedVerifications } from '../helpers';
import moment from "moment";
import CheckDateAvaliable from "./mixins/CheckDateAvaliable";

const selectedWidth = 300;
const selectedHeight = 250;

export default {
    mixins: [CheckDateAvaliable],
    components: {
        DatepickerInput,
        ReservationResourceSelector
    },
    props: {
        reservation: Object,
        position: Object,
        from: Number,
        widthUnit: Number,
        heightUnit: Number,
        offsetTop: Number,
        offsetLeft: Number,
        totalHeight: Number,
        totalWidth: Number,
        selected: Boolean,
        onSelection: Function,
        onDeletion: Function,
        zIndexCount: Number,
        onReschedule: Function,
        onReallocation: Function,
    },

    data(){
        return {
            initialized: false,
            rescheduling: false,
            zIndex: 0,
            scheduleDateValue: this.reservation.schedule_date,
            scheduleTimeMinutesValue: this.reservation.schedule_time_minutes || '',
            validation: null,
            displayChanges: false,
            displayReallocation: false,
            reallocationSeatMap: null,
            selectedReallocationResources: [],
            schedulings: [],
            productLoading: true,
            fromDate: moment(),
            toDate: moment().add(6, 'months'),
            scheduleTimeMinutesOptions: this.reservation.schedule_time_minutes_options,
            getProduct: function () {
                return this.reservation.product;
            },
            searchDate: function () {
                const schedulings = this.schedulings.filter(dates => dates.date === this.scheduleDateValue);
                return { date: this.scheduleDateValue, schedulings };
            },
            dateSelected: () => {
                return this.dateOptions?.find(date => date.value === this.scheduleDateValue);
            }
        };
    },

    computed: {
        customerName(){
            return this.reservation?.sale?.customer?.fullName ?? this.reservation.name;
        },
        dimensions(){
            const leftEdge = 0;

            let left = (this.position.start - this.from) * this.widthUnit;
            let top = this.position.row * this.heightUnit + 5 + this.offsetTop;
            let width = this.initialized ? this.position.size * this.widthUnit : 0;
            let height = this.heightUnit;

            if(this.selected){
                left += (width - selectedWidth) / 2;
                top += (height - selectedHeight) / 2;
                width = selectedWidth;
                height = selectedHeight;

                // Avoid edges
                top = Math.min(top, this.totalHeight - height);
                left = Math.min(left, this.totalWidth - width);
                top = Math.max(top, this.offsetTop);
                left = Math.max(left, this.offsetLeft);
            }

            return { left, top, width, height };
        },
        positionStyle(){
            const { left, top, width, height } = this.dimensions;

            return {
                left: `${left}px`,
                top: `${top}px`,
                width: `${width}px`,
                height: `${height}px`,
                zIndex: this.zIndex
            };
        },
        startHour(){
            return minToHour(this.reservation.schedule_time_minutes);
        },
        endHour(){
            const min = (this.reservation.schedule_time_minutes + this.reservation.duration_minutes) % MAX_MINUTE_DAY;
            return minToHour(min);
        },
        intervalString(){
            if(this.reservation.schedule_time_minutes === null)
                return ['Sem horário', `Duração ${minToHour(this.reservation.duration_minutes)}`].join(' - ');

            return [this.startHour, this.endHour].join(' - ');
        },
        rootClass(){
            let className = 'reservation-item';
            if(this.selected)
                className += ' selected';

            return className;
        },
        innerClass(){
            const { sale, all_vouchers_consumed } = this.reservation;

            let className = 'inner';
            if(sale){
                className += ' online';
            }

            if(all_vouchers_consumed){
                className += ' consumed';
            }

            return className;
        },
        reservationResourceIds(){
            return this.reservation.resources.map(r => r.id);
        },
        shouldDisplayTariffs(){
            return this.selected && this.reservation.tariffs.length > 0;
        },
        shouldDisplayResources(){
            return this.selected && this.reservation.resources.length > 0 && !this.displayReallocation;
        },
        shouldDisplayReallocation(){
            return this.selected && this.displayReallocation;
        },
        shouldDisplayDescription(){
            return this.selected && this.reservation.description != null;
        },
        shouldDisplayChanges(){
            return this.reservation.changes.length > 0;
        },
        shouldAllowReallocation(){
            return this.reservation.seat_map_available;
        },
    },

    methods: {
        toggleFull(){
            this.showFull = !this.showFull;
        },
        handleSelection(ev){
            ev.stopPropagation();

            if (!this.selected) {
                this.onSelection(this.reservation);
            }
        },
        handleDeletion(){
            if(!confirm('Tem certeza que deseja excluir esta reserva?'))
                return;

            const url = this.reservation.delete_url;
            this.onDeletion(url, json => this.handleDeletionResponse(json));
        },
        handleDeletionResponse(json){
            if(json.status === 'ok')
                this.onClose();
        },
        setReschedule(status){
            if(status) {
                this.requestAvailableDates();
            }
            this.rescheduling = status;
        },

        validationMessage(key){
            const { validation } = this;
            return validation && validation[key] ? validation[key].join(', ') : '';
        },
        handleRescheduleSubmit() {
            const errors = this.confirmationErrors();
            if (errors.length > 0 && !confirmValidationErrors(errors)) {
                return;
            }

            this.onReschedule(this.reservation.reschedule_url, this.scheduleDateValue, this.scheduleTimeMinutesValue);
        },
        confirmationErrors() {
            const arr = [];

            const date = this.searchDate();
            const isAvailable = date?.schedulings.some(sch => {
                return sch.scheduleAvailabilities.some(sa => sa.available && (this.productWithDateOnly || sa.minutes == this.scheduleTimeMinutesValue));
            });

            if(!isAvailable) {
                arr.push({
                    ok: false,
                    message: 'Data ou hora está indisponível, deseja continuar?',
                })
            }

            return arr
        },
        setChangesDisplay(status){
            this.displayChanges = status;
        },
        async setReallocation(status){
            this.displayReallocation = status;

            if (!status) {
                return;
            }

            this.reallocationSeatMap = null;

            const seatMap = await requestJson(this.reservation.reallocation_options_url);

            if (seatMap?.areas) {
                this.reallocationSeatMap = seatMap;
            } else {
                alert('A data dessa reserva não possui um agendamento com vinculação com nenhum mapa de lugares');
                this.displayReallocation = false;
            }
        },
        handleResourceSelectionChange(resources){
            this.selectedReallocationResources = resources;
        },
        handleReallocationSubmit(){
            const errors = [];

            for (let res of this.selectedReallocationResources) {
                errors.push({
                    ...validation.resourceIsAvailable(this.reallocationSeatMap, res, this.reservationResourceIds),
                    verifications: ['ignore_resource_availability']
                });
            }

            const tariffSum = this.reservation.tariffs.reduce((sum, t) => sum + t.quantity, 0);
            errors.push({
                ...validation.selectedResourcesCapacityMatchTariffQuantities(this.selectedReallocationResources, tariffSum),
                verifications: ['ignore_resources_total_capacity', 'ignore_allocation_resource_capacity']
            });

            if (this.reservation.tariffs_price_cents !== null) {
                errors.push({
                    ...validation.selectedResourcesPricingMatchOriginalPrice(this.reallocationSeatMap, this.selectedReallocationResources, this.reservation.tariffs_price_cents, this.reservation.resources_price_cents),
                    verifications: ['ignore_allocation_category_min_quantity']
                });
            }

            if (!confirmValidationErrors(errors)) {
                return;
            }

            this.onReallocation(
                this.reservation.reallocate_url,
                this.selectedReallocationResources.map(res => res.id),
                confirmedVerifications(errors)
            );
            this.setReallocation(false);
        },
        async requestAvailableDates(){
            this.productLoading = true;

            try {
                this.schedulings = await requestJson(this.reservation.reservation_reschedule_schedulings_url);
            } catch (err) {
                console.error(err);
            } finally {
                this.productLoading = false;
            }
        },
    },

    mounted(){
        setTimeout(() => this.initialized = true, 10);
    },
    beforeUpdate(){
        if(this.selected && this.zIndex != this.zIndexCount)
            this.zIndex = this.zIndexCount;
        if(!this.selected && this.rescheduling)
            this.rescheduling = false;
    }
}
</script>

<style lang="scss" scoped>
.reservation-item {
    position: absolute;
    box-sizing: border-box;
    width: 0;
    padding: 5px;
    transition: width .3s, height .3s, top .3s, left .3s;

    &.selected {
        z-index: 1;
    }
}

.reservation-item .inner {
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, .05);
    width: 100%;
    min-width: 100%;
    height: 100%;
    padding: 10px;
    overflow: auto;
    border-radius: 10px;
    font-size: .8rem;
    background: #ccc;
    cursor: pointer;
    box-shadow: 0px 0px 0px -0px #666;
    transition: box-shadow .3s, font-size .3s;
}
.reservation-item:not(.selected) .inner:hover {
    background: #bbb;
}
.reservation-item:not(.selected) .inner {
    overflow: hidden;
}
.reservation-item .inner.online {
    background: #77e4ff;
}
.reservation-item:not(.selected) .inner.online:hover {
    background: #66d3ee;
}
.reservation-item .inner.consumed {
    background: #91f5ad;
}
.reservation-item:not(.selected) .inner.consumed:hover {
    background: #80e49c;
}

.reservation-item .inner .data {
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.reservation-item .inner .actions {
    display: none;
    margin-top: 1rem;
}
.reservation-item.selected .inner a {
    color: #316d8a;
}
.reservation-item.selected .inner ul {
    margin: 0;
}
.reservation-item.selected .inner ul li {
    margin: 0;
}

.reservation-item.selected .inner {
    cursor: default;
    box-shadow: 1px 1px 6px 0 #666;
    font-size: .8rem;
}
.reservation-item.selected .inner .title {
    font-size: 1rem;
}

.reservation-item.selected .inner .actions {
    display: block;
    margin-top: 10px;
}
.reservation-item.selected .inner .actions div {
    margin-right: 5px;
    display: inline-block;
}
.reservation-item.selected .inner .actions .material-icons {
    font-size: 2.6rem;
}
.reservation-item.selected .inner .actions .button {
    background: #316d8a;
    color: #fff;
    color: #fff;
}

.reservation-item.selected .inner .changes {
    margin-top: 10px;
}

.reservation-item.selected .inner .reschedule-form {
    margin: 0;
}
.reservation-item.selected .inner .reschedule-form button {
    padding: 0;
}
</style>
